/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Alert, Button, Form, message, Tabs } from 'antd'
import PageLayout from '@layouts/PageLayout'
import { useLocalization } from '@contexts/LocalizationContext'
import { EditOutlined } from '@ant-design/icons'
import PrivilegesEn from './PrivilegesEn'
import PrivilegesTh from './PrivilegesTh'
import { client } from '@utils/client'

export const wellKidzClubPrivileges = 'wellKidzClub.privileges'
export const wellKidzClubButton = 'wellKidzClub.button'
export const wellKidzClubError = 'wellKidzClub.error'
const List = () => {
  // const fetchRef = useRef(null)
  const { t } = useLocalization()
  const [isEdit, setIsEdit] = useState(false)
  const [language, setLanguage] = useState('th')
  const [errorMessage, setErrorMessage] = useState()
  const [form] = Form.useForm()
  const style = {
    btn: { borderRadius: '5px', width: 'max-content', height: '40px' },
    btnSaveAndCacel: {
      borderRadius: '5px',
      width: '120px',
      height: '40px',
    },
  }
  const reset = () => {
    setErrorMessage(undefined)
  }

  const handleSubmit = async (data, language) => {
    try {
      await client.post(`/wellkidzclub/privilege/${language}`, data)
      setIsEdit(false)
      message.success('สำเร็จ')
    } catch (e) {
      if (e.response) setErrorMessage(e.response.data.message)
      message.error('ไม่สำเร็จ')
    }
  }
  const items = [
    {
      label: t(`${wellKidzClubPrivileges}.thaiLanguage`),
      key: 'th',
      children: (
        <>
          {errorMessage && (
            <Alert
              message={errorMessage}
              type="error"
              showIcon
              closable
              onClose={reset}
            />
          )}
          <div style={{ marginBottom: 8 }} />
          <PrivilegesTh
            isEdit={isEdit}
            handleSubmit={handleSubmit}
            form={form}
          />
        </>
      ),
    },
    {
      label: t(`${wellKidzClubPrivileges}.englishLanguage`),
      key: 'en',
      children: (
        <>
          {errorMessage && (
            <Alert
              message={errorMessage}
              type="error"
              showIcon
              closable
              onClose={reset}
            />
          )}
          <div style={{ marginBottom: 8 }} />
          <PrivilegesEn
            isEdit={isEdit}
            handleSubmit={handleSubmit}
            form={form}
          />
        </>
      ),
    },
  ]

  useEffect(() => {
    setErrorMessage(undefined)
    setIsEdit(false)
    fetch()
  }, [language])

  const fetch = async () => {
    try {
      const result = await client
        .get(`/wellkidzclub/privilege/${language}`)
        .then((res) => res.data)
      form.setFieldsValue(result)
    } catch (e) {
      if (e.response) setErrorMessage(e.response.data.message)
      message.error('ไม่สำเร็จ')
      console.log(e)
    }
  }

  return (
    <PageLayout
      title={t(`${wellKidzClubPrivileges}.specialPrivileges`)}
      shownBack={false}
      extra={
        isEdit
          ? [
              <Button
                type="danger"
                key="btnCacelData"
                onClick={() => {
                  setIsEdit(false)
                }}
                style={style.btnSaveAndCacel}
              >
                {t(`${wellKidzClubButton}.cancel`)}
              </Button>,
              <Button
                type="primary"
                key="btnSaveData"
                onClick={() => {
                  form.submit()
                }}
                style={style.btnSaveAndCacel}
              >
                {t(`${wellKidzClubButton}.save`)}
              </Button>,
            ]
          : [
              <Button
                type="primary"
                key="btnEditData"
                icon={<EditOutlined style={{ fontSize: 18 }} />}
                onClick={() => {
                  setIsEdit(true)
                }}
                style={style.btn}
              >
                {t(`${wellKidzClubButton}.editData`)}
              </Button>,
            ]
      }
    >
      <Tabs
        defaultActiveKey="1"
        items={items}
        onChange={(key) => {
          setLanguage(key)
        }}
      />
    </PageLayout>
  )
}

export default List
